<div class="row">
    <div class="col-md-12">
        <div class="card card-accent-success">
            <div class="card-header-buscador">
                <i class="fa fa-align-justify"></i> Documentación adjunta a la Solicitud
            </div>
    
            <div class="card-body-grid" *ngIf="documentosSolicitudCam">
    
                    <p-table #tableSearch autoLayout="true" [value]="documentosSolicitudCam" [lazy]="true"
                        [selectionMode]="'none'"
                        [lazyLoadOnInit]="false" [rowHover]="true"
                        [columns]="cols"
                        [totalRecords]="documentosSolicitudCam?.length" [loading]="loading"
                        [ngClass]="displayGridHidden(documentosSolicitudCam)"
                        styleClass="table table-responsive-sm  table-striped table-sm">
    
                    <ng-template pTemplate="header" let-columns>
                        <tr>
                            <th scope="col" *ngFor="let col of columns" [ngClass]="{ 'th-xs': col.reduce }" [ngStyle]="{'display': col.display}">
                                {{col.header}}
                            </th>
                        </tr>
                    </ng-template>
    
                        <ng-template pTemplate="body" let-rowData let-columns="columns" let-rowIndex="rowIndex">
                            <tr>
                                <td *ngFor="let col of columns" [ngStyle]="{'display': col.display}">
                                    <span *ngIf="col.field === 'Obligatoria'">
                                        {{ rowData[col.field] | siNo }}
                                    </span>
                                    <span *ngIf="col.field === 'Descripcion'" class="d-inline-block text-truncate titulo">
                                        {{ rowData[col.field] }}
                                    </span>
                                    <span *ngIf="col.field!=='Link' && col.field!=='Obligatoria' && col.field!=='Descripcion'">
                                        {{ rowData[col.field] }}
                                    </span>
                                    <div *ngIf="col.field==='Link'" class="btn-group">
                                        <ng-container *ngIf="rowData['MarkToDelete'] === 0 && !disabled">
                                            <button (click)="onRemoveDoc(rowData)" type="button" class="btn btn-sm btn-danger" title="Marcar para Eliminar Documentación">
                                                <span class="fa fa-remove"></span>
                                            </button>
                                        </ng-container>
                                        <ng-container *ngIf="rowData['MarkToDelete'] === 1 && !disabled">
                                            <button (click)="onUndoRemoveDoc(rowData)" type="button" class="btn btn-sm btn-warning" title="Deshacer Marcar para Eliminar">
                                                <span class="fa fa-undo"></span>
                                            </button>
                                        </ng-container>
                                        
                                        <button *ngIf="!disabled" (click)="onEditDoc(rowData)" type="button" title="Editar Documentación" class="btn btn-sm btn-warning">
                                            <span class="fa fa-edit"></span>
                                        </button>

                                        <button *ngIf="disabled" (click)="onViewDoc(rowData)" type="button" title="Consultar Documentación" class="btn btn-sm btn-info">
                                            <span class="fa fa-eye"></span>
                                        </button>
                                    </div>
                                </td>
                            </tr>
                        </ng-template>
                    </p-table>
                    
                    <div class="empty-grid" *ngIf="documentosSolicitudCam?.length === 0">No se ha encontrado ningún documento</div>
                    <div *ngIf="documentosSolicitudCam?.length === 1" class="p-2">Se han encontrado {{ documentosSolicitudCam.length | number:'1.0-0':'es-ES' }} documento</div>
                    <div *ngIf="documentosSolicitudCam?.length > 1" class="p-2">Se han encontrado {{ documentosSolicitudCam.length | number:'1.0-0':'es-ES' }} documentos</div>
                </div>
    
        </div>
    </div>
</div>
